import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { identityLabel } from '../identityLabel.mjs';

class ProviderProfileInternal extends Component {
    constructor(props) {
        super();
        this.state = {
            provider: {},
            invitation: {},
        };
    }

    componentDidMount() {
        this.getProfile()
    }

    async getProfile() {
        const res = await axios.get(
            '/api/providers/' + this.props.provider_id
        )
        const data = res.data;
        this.setState({
            provider: data.provider,
            invitation: data.invitation
        });
    }

    identityLabel() {
        return identityLabel(
            this.state.provider?.country_id,
            this.state.provider?.country_id == 2 ? 'RUT' : 'RFC'
        );
    }

    render() {
        return (<div>
            <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap row">
                    <div className="d-flex align-items-center flex-wrap col-5">
                        <div className="symbol symbol-40 mr-5">
                            <div className="symbol-label bg-primary text-white font-weight-bolder">
                            {this.state.provider.fiscal_name != null ? this.state.provider.fiscal_name[0] : ''}
                            </div>
                        </div>

                        <h5 className="text-dark font-weight-bold my-1 mr-5">
                            {this.state.provider.fiscal_name}
                            <br></br>
                            <div className="mt-2 font-size-sm">
                                <span className="text-muted font-weight-bold">{this.identityLabel()}: </span>
                                <span className="text-success mr-10">{this.state.provider.rfc}</span>
                            </div>
                        </h5>
                    </div>
                </div>
                <div className="text-center align-items-center flex-wrap col-3">
                    <span className="text-dark font-weight-bold">Estatus</span><br/>
                    <span className={'badge badge-'+((this.props.provider_active=='Activo')?'primary':'secondary text-muted')}>{this.props.provider_active}</span>
                </div>
            </div>
            <div className="text-center align-self-end p-sm-16 p-10 bg-white rounded border border-gray" style={{boxShadow: "0px 1px 15px rgba(0, 0, 0, 0.12)"}}>
                <div className="mt-2">

                    <div className="row text-left">
                        <div className="col-sm-6">
                            <p className="text-muted text-left font-weight-bold">Nombre</p>
                            <p className="text-left font-weight-bold">{this.state.provider.name}</p>
                        </div>
                    </div>

                    <div className="row text-left">
                        <div className="col-sm-6">
                            <p className="text-muted text-left font-weight-bold">Tipo de Persona</p>
                            <p className="text-left font-weight-bold">{this.state.provider.person_type}</p>
                        </div>

                        <div className="col-sm-6">
                            <p className="text-muted text-left font-weight-bold">{this.identityLabel()}</p>
                            <p className="text-left font-weight-bold">{this.state.provider.rfc}</p>
                        </div>
                    </div>

                    <div className="row text-left">
                        <div className="col-sm-6">
                            <p className="text-muted text-left font-weight-bold">Dirección</p>
                            <p className="text-left font-weight-bold">{this.state.provider.address1}</p>
                        </div>

                        <div className="col-sm-6">
                            <p className="text-muted text-left font-weight-bold">C.P.</p>
                            <p className="text-left font-weight-bold">{this.state.provider.zipcode}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}

export default ProviderProfileInternal;

if (document.getElementById('ProviderProfileInternal')) {
    ReactDOM.render(<ProviderProfileInternal />, document.getElementById('ProviderProfileInternal'));
}
